/**
 * Resolve the total item count for a vault category tab on a user's collection.
 * Race-used / collectibles mode shows all non-diecast collectibles.
 */
export function resolveVaultCategoryCount(profile, vaultMode) {
    if (!profile) return null;

    const totalCollectibles = Number(profile.numberOfCollectibles) || 0;
    const diecasts = Number(profile.numberOfDiecastCollectibles) || 0;
    const heroArchive = Number(profile.numberOfHeroCardsInArchive) || 0;

    if (vaultMode === 'diecasts') return diecasts;
    if (vaultMode === 'heroCards') return heroArchive;

    // raceUsed / collectibles hub: everything except diecasts
    return Math.max(0, totalCollectibles - diecasts);
}

/**
 * Sitewide browse totals for View Collectibles category tabs.
 * Uses SitewideData counters (not the current page of search results).
 */
export function resolveSitewideBrowseCategoryCount(sitewide, mainCategory, isDiecastsMode = false) {
    if (!sitewide) return null;

    const total = Number(sitewide.numberOfCollectibles) || 0;
    const raceUsed = Number(sitewide.numberOfRaceUsedCollectibles) || 0;
    const diecasts = Number(sitewide.numberOfDiecastCollectibles) || 0;
    const trading = Number(sitewide.numberOfTradingCardCollectibles) || 0;
    const hero = Number(sitewide.numberOfHeroCardCollectibles) || 0;
    const programs = Number(sitewide.numberOfProgramTicketCollectibles) || 0;

    if (isDiecastsMode || mainCategory === 'Diecasts') return diecasts;
    if (!mainCategory) return total;
    if (mainCategory === 'Race Used / Team Issued') return raceUsed;
    if (mainCategory === 'Trading Cards') return trading;
    if (mainCategory === 'Hero Cards / Post Cards') return hero;
    if (mainCategory === 'Programs / Tickets') return programs;
    if (mainCategory === 'Misc.') {
        return Math.max(0, total - raceUsed - diecasts - trading - hero - programs);
    }

    return total;
}

/**
 * Display count for vault hubs. Never contradict an empty feed with a stale profile total.
 */
export function resolveDisplayedVaultResultCount({
    categoryTotal,
    searchResultsLength,
    hasMore,
    loading,
    initialLoad,
    filtersActive,
}) {
    // Still fetching the first paint — avoid flashing a misleading total.
    if (initialLoad || (loading && searchResultsLength === 0)) {
        return null;
    }

    // Empty list on screen → always 0 (even if hasMore / profile total disagree).
    if (searchResultsLength === 0) {
        return 0;
    }

    if (filtersActive) {
        return searchResultsLength;
    }

    return categoryTotal ?? searchResultsLength;
}

export async function fetchUserCollectionProfile(apiFetch, userId) {
    if (!userId) return null;
    try {
        const response = await apiFetch('/Users/GetUserProfileData', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ userId: Number(userId) }),
        });
        if (!response.ok) return null;
        return await response.json();
    } catch (err) {
        console.error('Failed to fetch user collection profile:', err);
        return null;
    }
}
